import {
    AbstractControl, NgControl
} from "@angular/forms";
import {
    AfterViewInit, Directive, HostListener, inject
} from "@angular/core";

/**
 * This is used to clear input field with hotkeys.
 */
@Directive({ selector: "[mgdClearInput]" })
export class ClearInputDirective implements AfterViewInit {
    private readonly _ngControl = inject(NgControl);

    private _control: AbstractControl;

    /**
     * Detect hotKey "Ctrl + Backspace" to clear the input.
     */
    @HostListener("keydown", ["$event"]) hotKeyDetector(event: KeyboardEvent): void {

        if (event.ctrlKey && event.key === "Backspace") {

            this._control.setValue("");
        }
    }

    ngAfterViewInit(): void {

        this._control = this._ngControl.control;
    }
}
